<template>
    <span>
        <span>Employer tags:</span>
        <el-dropdown trigger="click">
            <button type="button" class="btn"><i class="fas fa-plus"></i> Add</button>
            <el-dropdown-menu slot="dropdown">
                <div v-for="c in colors" class="tags-option" :style="{'background' : c.color}" :command="c.id" @click="addTag(c.id)">{{ c.name }}</div>
            </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click">
            <button type="button" class="btn"><i class="fas fa-minus"></i> Remove</button>
            <el-dropdown-menu slot="dropdown">
                <div v-for="c in colors" class="tags-option" :style="{'background' : c.color}" :command="c.id" @click="removeTag(c.id)">{{ c.name }}</div>
            </el-dropdown-menu>
        </el-dropdown>
    </span>
</template>

<script>
export default {
    props: [
        'colors',
        'selected'
    ],
    data() {
        return {
        };
    },
    methods: {
        addTag(tag_id) {
            axios.post(url(`admin/list-employer/tags/assign`), {
                ids: this.selected,
                tag: tag_id
            }).then(() => {
                this.$emit('updated');
            });
        },
        removeTag(tag_id) {
            axios.post(url(`admin/list-employer/tags/unassign`), {
                ids: this.selected,
                tag: tag_id
            }).then(() => {
                this.$emit('updated');
            });
        },
    }
}
</script>

<style>
    .tags-option {
        cursor: pointer;
        width: 150px;
        color: white;
        font-weight: bold;
        padding: 8px;
        border-radius: 5px;
        margin: 3px 10px;
    }
</style>
